export const getIsDomainKnowledge = (selectedDomain: number, domainKnowledgeId = 10) =>
  selectedDomain === domainKnowledgeId;
